/* global axios */
import ApiClient from '../ApiClient';

class MicrosoftChannelClient extends ApiClient {
  constructor() {
    super('microsoft/channels', { accountScoped: true });
  }

  create(payload) {
    return axios.post(`${this.url}`, payload);
  }
}

export default new MicrosoftChannelClient();
